module.exports = __webpack_public_path__ + "img/icon-meteo-3@2x.54f6eb3c.png";